import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';
import { CheckboxEntry } from '../entries/CheckboxEntry';

export class ParticipantPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:Participant';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'participant',
        label: i18n.participant || 'Participant',
        entries: [
          {
            id: 'participantName',
            component: () => (
              <TextFieldEntry
                id="epx-participant-name"
                label={i18n.name || 'Name'}
                value={props.name || ''}
                onChange={(val) => update('name', val)}
              />
            ),
          },
          {
            id: 'processRef',
            component: () => (
              <TextFieldEntry
                id="epx-participant-processRef"
                label={i18n.processRef || 'Process Ref'}
                value={props.processRef || ''}
                onChange={(val) => update('processRef', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
